<template>
  <div id="app" style="flex:1">
    <TheHeader
      v-if="$route.name !== 'privacy-policy' && $route.name !== 'home'"
    />
    <RouterView></RouterView>
  </div>
</template>

<style>
@import '~roboto-fontface/css/roboto/roboto-fontface.css';
#app {
  display: flex;
  flex-direction: column;
  max-height: 100%;
  font-family: Roboto-Regular;
}
</style>

<script>
import TheHeader from './components/TheHeader'
import router from './router/router'
export default {
  name: 'App',
  router,
  components: { TheHeader },
  created() {
    document.title = 'Headstart'
  },
}
</script>
